export const convertEmailPreviewFiveSimvol = (str) => {
     if (str.length <= 5) {
    return str; 
  }
  const visiblePart = str.slice(0, 5);
  const hiddenPart = '*'.repeat(str.length - 5);
  return visiblePart + hiddenPart;
}
